<template>
  <v-data-table-server
    :density="density"
    :headers="headers"
    :hide-default-footer="!totalItems"
    :items="items"
    :items-length="totalItems"
    :items-per-page="itemsPerPage"
    :loading="loading"
    :page="page"
    :show-select="showSelect"
    fixed-header
    @update:options="onchangePagination"
  >
    <template v-slot:[`item.id`]="{ item }">
      <div class="d-flex cursor-pointer">
        <span class="table-link" @click="$emit('edit', item)">{{
          item.id
        }}</span>
        <v-icon
          class="text-muted ml-2"
          size="16"
          @click="copyToClipboard(item.id)"
        >
          mdi-content-copy
        </v-icon>
      </div>
    </template>

    <template v-slot:[`item.role`]="{ item }">
      <v-chip
        class="text-uppercase"
        :color="item.role == 'admin' ? 'warning' : 'blue'"
        :text="item.role"
        size="x-small"
      ></v-chip>
    </template>

    <template v-slot:[`item.phoneNumber`]="{ item }">
      <div class="d-flex justify-space-evenly">
        <p
          class="table-link cursor-pointer"
          @click="$emit('edit', item, { phoneNumber: item.phoneNumber })"
        >
          {{ item.phoneNumber }}
        </p>
        <v-icon
          class="text-muted"
          size="16"
          @click="copyToClipboard(item.phoneNumber)"
        >
          mdi-content-copy
        </v-icon>
      </div>
    </template>
    <!--  -->
    <template v-slot:[`item.status`]="{ item }">
      <v-switch
        :model-value="item.status"
        color="green"
        density="compact"
        hide-details
        @update:modelValue="updateStatus(item)"
      />
    </template>
    <!-- paymentStatus -->
    <template v-slot:[`item.paymentStatus`]="{ item }">
      <v-chip
        size="small"
        variant="tonal"
        :color="item.paymentStatus ? 'success' : 'error'"
      >
        {{ item.paymentStatus }}
      </v-chip>
    </template>

    <template v-slot:[`item.image`]="{ item }">
      <div class="image-hover">
        <v-img
          :src="item.imageUrl"
          width="50"
          height="50"
          class="rounded-lg"
          contain
        />
      </div>
    </template>

    <!-- Amount Status -->
    <template v-slot:[`item.amountStatus`]="{ item }">
      <v-chip
        :color="item.amountStatus === 'Debited' ? 'green' : 'red'"
        size="x-small"
        class="text-uppercase"
      >
        {{ item.amountStatus }}
      </v-chip>
    </template>

    <template v-slot:[`item.settlementStatus`]="{ item }">
      <v-chip
        :color="item.settlementStatus === 'settled' ? 'green' : 'red'"
        size="x-small"
        class="text-uppercase"
      >
        {{ item.settlementStatus }}
      </v-chip>
    </template>

    <!-- Booking Status -->
    <template v-slot:[`item.bookingStatus`]="{ item }">
      <v-chip
        :color="
          ['Booked', 'Completed'].includes(item.bookingStatus) ? 'green' : 'red'
        "
        size="x-small"
        class="text-uppercase"
      >
        {{ item.bookingStatus }}
      </v-chip>
    </template>

    <!-- Refund Status -->
    <template v-slot:[`item.refundStatus`]="{ item }">
      <v-chip
        :color="item.refundStatus ? 'red' : 'green'"
        size="x-small"
        class="text-uppercase"
        @click="$emit('initiateRefund', item)"
      >
        {{ item.refundStatus ? "Refund" : "No Refund" }}
      </v-chip>
    </template>

    <!-- Booking Device -->
    <template v-slot:[`item.bookingDevice`]="{ item }">
      <v-chip
        :color="item.bookingDevice ? 'violet' : 'blue'"
        size="x-small"
        class="text-uppercase"
      >
        {{ item.bookingDevice ? "Web Booking" : "Mobile Booking" }}
      </v-chip>
    </template>

    <!-- Created By -->
    <template v-slot:[`item.createdBy`]="{ item }">
      <v-chip
        color="violet"
        size="x-small"
        class="text-uppercase"
        @click="getAdminDetails(item)"
      >
        {{ item.createdBy }}
      </v-chip>
    </template>

    <!-- Updated By -->
    <template v-slot:[`item.updatedBy`]="{ item }">
      <v-chip
        color="violet"
        size="x-small"
        class="text-uppercase"
        @click="getAdminDetails(item)"
      >
        {{ item.createdBy }}
      </v-chip>
    </template>

    <template v-if="actionType" v-slot:[`item.actions`]="{ item }">
      <v-icon
        v-if="actionType.includes('view')"
        @click="$emit('view', item)"
        class="mx-2"
        color="warning"
        size="18"
        >mdi-eye-circle
      </v-icon>
      <v-icon
        v-if="actionType.includes('edit')"
        @click="$emit('edit', item)"
        size="18"
        >
        mdi-square-edit-outline
        </v-icon>
      <v-icon
        v-if="actionType.includes('delete')"
        @click="$emit('delete', item)"
        size="18"
        class="mx-2 text-red"
        >mdi-delete</v-icon
      >
    </template>
    <template v-slot:[`item.routes`]="{ item }">
      <div class="d-flex flex-column ga-1">
        <div
          v-for="route in item.routes"
          :key="route.routeId"
          class="d-flex align-center"
        >
          <v-icon size="16" class="mr-1">
            mdi-map-marker-outline
          </v-icon>

          <span>{{ route.routeId }}</span>

          <span class="text-medium-emphasis mx-1">({{ route.cityId }})</span>

          <v-chip size="x-small" variant="tonal">
            {{ route.usageCount }} usage
          </v-chip>
        </div>
      </div>
    </template>
    <template v-slot:no-data>
      <div class="d-flex justify-center">
        <v-img
          src="/images/NoDataFound.png"
          width="300"
          aspect-ratio="1"
          class="flex-grow-0"
        />
      </div>
    </template>
  </v-data-table-server>
</template>

<script>
import { mapState } from "pinia";
import { useUiStore } from "@/store";

export default {
  name: "RbDataTable",

  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      addUpdatedByKeyRoutes: ["AdvertisementList"],
    };
  },

  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    density: {
      type: String,
      default: "comfortable",
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
    actionType: {
      type: Array,
      default: () => ["edit", "delete"],
    },
    updateApi: {
      type: Function,
      default: null,
    },
    fetchData: {
      type: Function,
      default: null,
    },
  },

  computed: {
    ...mapState(useUiStore, {
      loading: "getLoading",
    }),
  },
  methods: {
    getAdminDetails(admin) {
      this.$router.push({ name: "viewAdmin", params: { id: admin.createdBy } });
    },
    onchangePagination(options) {
      if ( options.page == this.page && options.itemsPerPage == this.itemsPerPage) return;

      this.page = options.page;
      this.itemsPerPage = options.itemsPerPage;
      this.fetchData({
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      });
    },

    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$showNotification("Copied Succesfully", "success");
      } catch (err) {
        this.$showNotification("Failed To Copy", "error");
      }
    },
    updateStatus(item) {
      const options = {
        item,
        updateApi: this.updateApi,
        fetchData: this.fetchData,
      };

      if (this.addUpdatedByKeyRoutes.includes(this.$route.name)) {
        options.payload = {
          updated_by: this.$auth.email,
        };
      }

      this.page = 1;
      this.itemsPerPage = 10;
      this.$helper.updateStatus(options);
    },
  },
};
</script>

<style scoped>
:deep(.v-data-table__thead th) {
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 0.2px;
  white-space: nowrap;
}
.v-theme--light :deep(.v-data-table__thead th) {
  background-color: #f6f7f9 !important;
  color: #0c0c0ceb !important;
}
.v-theme--dark :deep(.v-data-table__thead th) {
  color: white;
}
.v-theme--dark :deep(.v-data-table__td) {
  color: rgb(221, 221, 221);
}
:deep(.v-data-table__td) {
  color: #3e4045;
  font-size: 13.8px;
  white-space: nowrap;
  text-transform: capitalize;
}
.table-link {
  color: #3366cc;
  text-decoration: underline;
}
.image-hover {
  display: inline-block;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.image-hover:hover {
  transform: scale(3); /* Increase size */
  z-index: 1000;
  position: relative;
}
</style>
